// extracted by mini-css-extract-plugin
export default {"pages":"Pagination_pages__HcCCP","btn_page":"Pagination_btn_page__fbgh9"};